import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Modal,
  Pressable,
} from "react-native";
import {
  color_main,
  color_BEBEBE,
  color_333333,
  white,
  ColorF6F6F6,
  ColorF4F4F4,
} from "../../assets/style/colors";
import React, { useState, useEffect, useRef } from "react";
import globalEventBus from "../../utils/EventBus";
import { searchFriend } from "../../net/service";
import { User } from "../../../imsdk/db/t_user";
import { getAvatarByItem } from "../../utils/utils";
import {
  Str_Account,
  Str_AddFriends,
  Str_Email,
  Str_Phone,
  Str_Search,
  Str_Searching,
  Str_UserDoesNotExist,
} from "../../language/string_res";
import { getUserName } from "./chat-helper";
import { UserSchema } from "../../realm/contactSchema";
import { LeftView } from "./CListItem";
import { MainNavProps } from "../navigation/main/MainParamList";

export const SearchFriend = ({
  navigation,
  route,
}: MainNavProps<"SearchFriend">) => {
  const [search, setSearch] = useState ("");
  const [loading, setLoading] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [failMsg, setFailMsg] = useState(Str_UserDoesNotExist);
  const [data, setData] = useState<User | UserSchema>();
  const dataRef = useRef<User | UserSchema>();

  // 始终保持 dataRef 指向最新 data
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  // 监听备注修改事件，自动刷新搜索结果中的备注
  useEffect(() => {
    const handleRemarkObj = (payload: any) => {
      const cur = dataRef.current;
      if (payload && payload.user_remark && cur && 'uid' in cur && payload.user_remark.uid === cur.uid) {
        setData({ ...cur, remark: payload.user_remark.remark });
      }
    };
    globalEventBus.on('Set_Remark_USER', handleRemarkObj);
    return () => {
      globalEventBus.off('Set_Remark_USER', handleRemarkObj);
    };
  }, []);

  function searchApi() {
    if (loading) {
      return;
    }
    setLoading(true);
    setIsSearch(false);
    searchFriend({ account: search })
      .then((resp) => {
        setIsSearch(true);
        if (resp && resp.code === 0) {
          if (resp.data && resp.data.users && resp.data.users.length > 0) {
            setData(resp.data.users[0]);
          } else {
            setData(undefined);
          }
        } else {
          if (resp.msg && resp.msg.length > 0) {
            setFailMsg(resp.msg);
          }
          setData(undefined);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleItemClick(item: User | UserSchema) {
    navigation.navigate("ContactInfoModeal", { current: item ,finishAll:true});
  }

  const renderResult = () => {
    if (data) {
      const left = getAvatarByItem({ ...data, frontType: "single" });
      return (
        <View style={styles.resultContainer}>
          <TouchableOpacity
            style={styles.resultItem}
            onPress={() => handleItemClick(data)}
          >
            <LeftView left={left} />
            <View style={styles.userInfo}>
              <Text style={styles.userName}>{getUserName(data)}</Text>
              <Text style={styles.userAccount}>
                {data.employee||data.email || data.telno || data.uid.toString()}
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      );
    } else if (search && isSearch) {
      return (
        <View style={styles.noContainer}>
          <Text style={styles.noResultText}>{failMsg}</Text>
        </View>
      );
    }
    return null;
  };
  function onClose() {
    navigation.goBack();
  }
  return (
    <Pressable style={styles.overlay} onPress={onClose}>
      {/* 弹窗内容 */}
      <Pressable
        style={styles.modalContainer}
        onPress={(e) => e.stopPropagation()}
      >
        {/* 弹窗头部 */}
        <View style={styles.header}>
          <Text style={styles.headerTitle}>{Str_AddFriends}</Text>
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Text style={styles.closeButtonText}>✕</Text>
          </TouchableOpacity>
        </View>

        {/* 搜索框 */}
        <View style={styles.searchContainer}>
          <View style={styles.search}>
            <View style={styles.searchIconContainer}>
              <Text style={styles.searchIcon}>🔍</Text>
            </View>
            <TextInput
              placeholder={`${Str_Account} / ${Str_Email} / ${Str_Phone}`}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              value={search}
              style={styles.searchText}
              returnKeyType={"search"}
              onSubmitEditing={searchApi}
              onChangeText={(text) => {
                setSearch(text);
              }}
            />
            {search.length > 0 && (
              <TouchableOpacity
                style={styles.clearButton}
                onPress={() => setSearch("")}
              >
                <Text style={styles.clearButtonText}>✕</Text>
              </TouchableOpacity>
            )}
          </View>

          {/* 搜索按钮 */}
          {search.length > 0 && (
            <TouchableOpacity
              style={styles.searchButton}
              onPress={() => {
                searchApi();
              }}
            >
              <Text style={styles.searchButtonText}>{Str_Search}</Text>
            </TouchableOpacity>
          )}
        </View>

        {/* 搜索结果 */}
        <View style={styles.content}>
          {loading ? (
            <View style={styles.loadingContainer}>
              <Text style={styles.loadingText}>{Str_Searching}</Text>
            </View>
          ) : (
            renderResult()
          )}
        </View>
      </Pressable>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  // 遮罩层样式
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    minHeight: "50%",
  },
  // 弹窗容器样式
  modalContainer: {
    backgroundColor: white,
    borderRadius: 12,
    width: "100%",
    maxWidth: 600,
    maxHeight: "80%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  // 弹窗头部样式
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: ColorF6F6F6,
    backgroundColor: "#FAFAFA",
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: color_333333,
  },
  closeButton: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "transparent",
  },
  closeButtonText: {
    fontSize: 20,
    color: color_333333,
    lineHeight: 20,
  },
  // 搜索容器样式
  searchContainer: {
    padding: 16,
    backgroundColor: white,
  },
  // 搜索框样式
  search: {
    borderRadius: 8,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    backgroundColor: ColorF4F4F4,
    height: 44,
  },
  searchIconContainer: {
    marginRight: 8,
  },
  searchIcon: {
    fontSize: 18,
    color: color_BEBEBE,
  },
  searchText: {
    fontSize: 16,
    color: color_333333,
    flex: 1,
    paddingVertical: 0,
    height: "100%",
    textAlignVertical: "center",
  },
  // 清除按钮样式
  clearButton: {
    padding: 8,
    borderRadius: 4,
  },
  clearButtonText: {
    fontSize: 16,
    color: color_BEBEBE,
    lineHeight: 16,
  },
  // 搜索按钮样式
  searchButton: {
    marginTop: 12,
    backgroundColor: color_main,
    borderRadius: 8,
    paddingVertical: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  searchButtonText: {
    color: white,
    fontSize: 16,
    fontWeight: "500",
  },
  // 内容区域样式
  content: {
    flex: 1,
    padding: 16,
    backgroundColor: white,
  },
  // 结果容器样式
  resultContainer: {
    marginTop: 8,
  },
  // 结果项样式
  resultItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    backgroundColor: "#F8F9FA",
    borderRadius: 8,
  },
  // 用户信息样式
  userInfo: {
    flex: 1,
  },
  // 用户名样式
  userName: {
    fontSize: 16,
    fontWeight: "500",
    color: color_333333,
    marginBottom: 4,
  },
  // 用户账号样式
  userAccount: {
    fontSize: 14,
    color: color_BEBEBE,
  },
  // 无结果容器样式
  noContainer: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
    backgroundColor: "#F8F9FA",
    borderRadius: 8,
  },
  // 无结果文本样式
  noResultText: {
    fontSize: 16,
    color: color_BEBEBE,
  },
  // 加载中容器样式
  loadingContainer: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
    backgroundColor: "#F8F9FA",
    borderRadius: 8,
  },
  // 加载中文本样式
  loadingText: {
    fontSize: 16,
    color: color_BEBEBE,
  },
});
